import { render, staticRenderFns } from "./MembersCardPage.vue?vue&type=template&id=6c19b724&"
import script from "./MembersCardPage.vue?vue&type=script&lang=js&"
export * from "./MembersCardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports